import CellLink from '@/components/GokuDataGrid/CellLink'
import { AffiliateCandidateContact } from '@/modules/Affiliate/types'
import { generatePathDatacentral, paths } from '@/utils/path'
import { TFunction } from 'i18next'
import { NavigateFunction } from 'react-router-dom'
import { Button, Typogaphy } from 'vnetwork-ui'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'

export const affiliateCandidateColumns = (
    t: TFunction,
    navigate: NavigateFunction
): GridColDefVNW<AffiliateCandidateContact>[] => [
    {
        field: 'contact_name',
        headerName: t('contact_name'),
        sortable: false,
        renderCell: ({ row }) => (
            <CellLink
                to={`${generatePathDatacentral(paths.customerDetail, {
                    id: String(row?.customer_id),
                })}?contact_id=${row?.customer_contact_id}`}
            >
                {row?.contact_name || '-'}
            </CellLink>
        ),
        minWidth: 220,
        flex: 1,
    },
    {
        field: 'customer_name',
        headerName: t('customer_name'),
        sortable: false,
        renderCell: ({ row }) => (
            <CellLink
                to={generatePathDatacentral(paths.customerDetail, {
                    id: String(row?.customer_id),
                })}
            >
                {row?.customer_name || '-'}
            </CellLink>
        ),
        minWidth: 200,
    },
    {
        field: 'contact_email',
        headerName: t('email'),
        sortable: false,
        minWidth: 220,
    },
    {
        field: 'contact_phone',
        headerName: t('phone'),
        sortable: false,
        width: 140,
    },
    {
        field: 'contact_roles',
        headerName: t('roles'),
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy>{row?.contact_roles?.join(', ') || '-'}</Typogaphy>
        ),
        width: 160,
    },
    // No linked-state column here: getAffiliateCandidates requests exclude_linked=true, so this tab
    // only ever receives contacts whose company has no affiliate yet. A badge that always reads
    // "Chưa liên kết" would be noise, and the tab title already says it.
    {
        field: 'actions',
        headerName: t('actions'),
        sortable: false,
        renderCell: ({ row }) => {
            const params = new URLSearchParams({
                customer_id: String(row.customer_id),
                referrer_name: row.contact_name || '',
                referrer_email: row.contact_email || '',
                referrer_phone: row.contact_phone || '',
                referrer_company: row.customer_name || '',
            })

            return (
                <Button
                    variant="contained"
                    onClick={() =>
                        navigate(`${paths.affiliateCreate}?${params}`)
                    }
                >
                    {t('create_affiliate')}
                </Button>
            )
        },
        width: 180,
    },
]
